import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import ApiService from "../../../service/ApiService";
import { apiPaths } from "../../../service/apiPaths";

 const useCreateArticle = ()=>{
    const [loading , setLoading] = useState(false) 
    const[courses , setCourses] = useState<any[]>([]);
    const[standards , setStandard] = useState<any[]>([]) ;
    const[categories , setCategory] = useState<any[]>([])

    useEffect(()=>{
      fetchCoursesAndLanguages()
    } , [])
    


    const handleSubmit = async(formData :any)=>{
        try {
            setLoading(true)
           const response =  await ApiService( {
            method:"POST" ,
            endpoint:apiPaths.createArticle ,
            headers: {
                'Content-Type': 'application/json',
              },
              data:formData

            });
         
            return response

          } catch (error:any) {
            toast.error(error?.response?.data?.message || "Failed to create article");
          }
      

        
    }


    const fetchCoursesAndLanguages = async () => {
      try {
        setLoading(true);
        const [
          coursesResponse,
          categoryResponse,
          standardResponse,
        ] = await Promise.all([
          ApiService({ method: "GET", endpoint: apiPaths.getCourse }),
          ApiService({ method: "GET", endpoint: apiPaths.getAllCategories }),
         
          ApiService({ method: "GET", endpoint: apiPaths.getStandard }),
        ]);
  
        setCourses(coursesResponse);
        setCategory(categoryResponse)
       
        setStandard(standardResponse);
      } catch (error) {
        console.error("Error fetching courses and languages:", error);
        toast.error("Failed to fetch courses or languages."); // Show error toast
      } finally {
        setLoading(false);
      }
    };

    return {handleSubmit , categories , courses , standards}
}


export default useCreateArticle

